<template>
<div>

  <v-flex md12 v-if="pdfsLoading && !pdfs.application">
      <v-progress-circular
      :size="50"
      :width="10"
      color="red"
      indeterminate
      ></v-progress-circular>
      <span> Generating PDF's </span>
  </v-flex>
  <span v-if="pdfs.application">
    <v-flex><a data-file="application" :href="pdfs.application" target="_blank"><v-icon large color="red">insert_drive_file</v-icon> Application for registration</a></v-flex>
    <v-flex><a data-file="billofsales" :href="pdfs.BillOfSales" target="_blank"><v-icon large color="red">insert_drive_file</v-icon> Bill of Sales</a></v-flex>
    <v-flex><a data-file="declaration" :href="pdfs.declaration" target="_blank"><v-icon large color="red">insert_drive_file</v-icon> Declaration of International Flight</a></v-flex>
  </span>

  <v-flex md12 v-if="docsLoading && !docs.link">
      <v-progress-circular
      :size="50"
      :width="10"
      color="primary"
      indeterminate
      ></v-progress-circular>
      <span> Generating Docs </span>
  </v-flex>
  <v-flex md12 v-if="docs.link">
    <a data-file="trust" :href="docs.link" target="_blank"> <v-icon large color="blue">insert_drive_file</v-icon> Trust Document </a>
  </v-flex>
  <v-spacer/>
</div>
</template>

<script>
export default {
  data: () => ({}),
  props: ["cotrustor"],
  computed: {
    pdfsLoading() {
      return this.$store.getters.loadingPdfs;
    },
    docsLoading() {
      return this.$store.getters.loadingDocs;
    },
    pdfs() {
      return this.$store.getters.pdfs;
    },
    docs() {
      return this.$store.getters.docs;
    }
  },
  methods: {}
};
</script>

<style>
</style>
